<script>
import { mapGetters } from 'vuex';
import { useBrowserPhoneStore } from 'dashboard/modules/browserPhone/store/browserPhone';
import SidebarProfileMenu from 'next/sidebar/SidebarProfileMenu.vue';

export default {
  name: 'FunctionBar',
  components: {
    SidebarProfileMenu,
  },
  computed: {
    ...mapGetters({
      canUseNativeBrowserPhone: 'getCurrentAccountHasBrowserPhoneAccess',
    }),
  },
  methods: {
    toggleBrowserPhoneVisibility() {
      const browserPhoneStore = useBrowserPhoneStore();

      if (browserPhoneStore.isWidgetOpen) {
        browserPhoneStore.close();
        return;
      }

      browserPhoneStore.open({ source: 'function_bar' });
    },
  },
};
</script>

<template>
  <div class="function-bar">
    <div class="left-content">
      <img
        src="../../assets/images/logo-hoje-telecom.png"
        alt="Hoje360"
        class="image-proportional"
      />
    </div>

    <div class="right-content">
      <button
        v-if="canUseNativeBrowserPhone"
        id="browser-phone-toggle-button"
        type="button"
        class="phone-button"
        :aria-label="$t('FUNCTION_BAR.TOGGLE_PHONE')"
        @click="toggleBrowserPhoneVisibility"
      >
        <img
          src="../../assets/images/phone-icon.svg"
          :alt="$t('FUNCTION_BAR.TOGGLE_PHONE')"
          class="phone-button"
        />
      </button>
      <SidebarProfileMenu
        class="flex items-center justify-end avatar-function-bar"
        :is-collapsed="true"
        variant="functionbar"
      />
    </div>
  </div>
</template>

<style scoped>
.function-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #22226d;
  padding: 10px 20px;
  color: white;
  height: 70px;
  flex-shrink: 0;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border: 1px solid #000;
}

.left-content {
  font-weight: bold;
}

.image-proportional {
  width: 101px;
  height: 42px;
  flex-shrink: 0;
  object-fit: contain;
}

.right-content {
  display: flex;
  align-items: center;
  width: 450px;
}

.phone-button {
  width: 39px;
  height: 39px;
  flex-shrink: 0;
  background-color: #fff;
  margin-right: 16px;
}

.phone-button img {
  width: 100%;
  height: auto;
}

.avatar-function-bar {
  width: 39px;
  height: 39px;
  flex-shrink: 0;
}

.avatar-function-bar button span div .avatar-container {
  width: 39px;
  height: 39px;
  background: red;
}

.avatar-function-bar button span div img {
  width: 39px;
  height: 39px;
  background: yellow;
}
</style>
